import { tw } from '@/utils/tw';
import BaseBlipTheme from 'base/components/Blip/theme';

const Blip = tw.theme({
  extend: BaseBlipTheme,
  base: `bg-cherry-blossom-500 before:bg-cherry-blossom-500 after:bg-cherry-blossom-500`,
});

export default Blip;
